export const assessment = state => state.assessment
